import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import DonateButton from "../donateButton/DonateButton";
import SocialLinks from "../socialLinks/SocialLinks";
import { useLanguage } from "../../context/LanguageContext";

const BurgerButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: none;
  align-items: center;
  justify-content: center;
  padding: 4px;

  svg {
    width: 32px;
    height: 32px;
    color: var(--text-in-boxes);
  }

  @media (max-width: 1200px) {
    display: flex;
  }
`;

const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: flex-end;
  z-index: 99;
`;

const ModalContent = styled(motion.div)`
  background: var(--header-bg);
  width: 240px;
  border-radius: 20px 0 0 20px;
  padding: 42px 30px 42px 25px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: flex-start;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;

  svg {
    width: 28px;
    height: 28px;
    color: var(--text-in-boxes);
  }
`;

const NavLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const NavLink = styled(Link)`
  color: var(--text-in-boxes);
  text-decoration: none;
  font-size: 18px;
  font-weight: 600;
  padding: 8px 0;
  width: fit-content;
  &:hover {
    border-bottom: 2px solid var(--text-in-boxes);
  }
`;

const BurgerMenu: React.FC = () => {
  const { language } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Закрываем меню при переходе на другой путь
  useEffect(() => {
    if (isOpen) {
      setIsOpen(false);
    }
  }, [location.pathname]);

  return (
    <>
      <BurgerButton onClick={() => setIsOpen(true)}>
        <Menu />
      </BurgerButton>

      <AnimatePresence>
        {isOpen && (
          <ModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsOpen(false)}
          >
            <ModalContent
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "spring", stiffness: 100 }}
              onClick={(e) => e.stopPropagation()}
            >
              <CloseButton onClick={() => setIsOpen(false)}>
                <X />
              </CloseButton>

              <NavLinks>
                <NavLink to="/">{language === "ME" ? "POČETNA" : "HOME"}</NavLink>
                <NavLink to="/mission">{language === "ME" ? "NAŠA MISIJA" : "OUR MISSION"}</NavLink>
                <NavLink to="/partners">{language === "ME" ? "KORPORATIVNI PARTNERI" : "CORPORATE PARTNERS"}</NavLink>
                <NavLink to="/contact-us">{language === "ME" ? "KONTAKTIRAJTE NAS" : "CONTACT US"}</NavLink>
                <NavLink to="/volunteer">{language === "ME" ? "VOLONTIRAJTE" : "VOLUNTEER"}</NavLink>
              </NavLinks>

              <DonateButton />
              <SocialLinks
                instagramSize={40} 
                facebookSize={30}
                isVisible={true}
                instagramUrl="https://www.instagram.com/novanit_pg/"
                facebookUrl="https://www.facebook.com/NovaNitPG/"
              />
            </ModalContent>
          </ModalOverlay>
        )}
      </AnimatePresence>
    </>
  );
};

export default BurgerMenu;
